import { render } from "./LayoutMinimal.vue?vue&type=template&id=95c60b6e&scoped=true"
import script from "./LayoutMinimal.vue?vue&type=script&lang=js"
export * from "./LayoutMinimal.vue?vue&type=script&lang=js"

import "./LayoutMinimal.vue?vue&type=style&index=0&id=95c60b6e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c60b6e"]])

export default __exports__